export default {
  "header": {
    "search": "Procurar"
  },
  "help": {
    "code": "Corresponde ao identificador único do condutor, na qual pode ser sua rota ou outro código definido pela empresa.",
    "codeVehicle": "Corresponde ao identificador único do equipamento, na qual pode ser sua placa de registro veicular ou outro código definido pela empresa.",
    "codeSemiTrailer": "Corresponde ao identificador único da carreta, na qual pode ser sua placa de registro veicular ou outro código definido pela empresa.",
    "codeGeo": "Corresponde ao código identificador da geozona.",
    "dataSource": "Corresponde aos códigos do condutor provenientes de fontes de informação externas: SAP, ERP’s, outros.",
    "dataSourceVehicle": "Corresponde aos códigos do equipamento provenientes de fontes de informação externas: SAP, ERP’s, outros.",
    "dataSourceSemiTrailer": "Corresponde aos códigos da carreta provenientes de fontes de informação externas: SAP, ERP’s, outros.",
    "workingShiftGroupHelp": "Corresponde ao grupo de rotação de turno ao que está atribuída a pessoa na data de consulta.",
    "state": {
      "title": "Representa o estado de associação a fontes de informação.",
      "listDatasource": {
        "name": "-Associado a fonte de informação",
        "text": ": Condutor com ao menos uma fonte de informação configuradas na plataforma.",
        "textVehicle": ": equipamento com ao menos uma fonte de informação configuradas na plataforma.",
        "textSemiTrailer": ": carreta com ao menos uma fonte de informação configuradas na plataforma."
      },
      "noListDatasource": {
        "name": "-Sem associações a fontes de informação",
        "text": ": Condutor sem ninguma fonte de informação associada.",
        "textVehicle": ": equipamento Sem ninguma fonte de informação associada.",
        "textSemiTrailer": ": carreta Sem ninguma fonte de informação associada."
      }
    }
  },
  "expire": {
    "vehicules": {
      "title": "Associação equipamento"
    },
    "semiTrailers": {
      "title": "Associação carreta"
    },
    "text": "a conexão expirou"
  },
  "title": {
    "driver": "Lista de condutores",
    "vehicules": "Lista de equipamentos",
    "semiTrailers": "Lista de carretas",
    "homologation": "Condutores desconhecidos",
    "homologationVehicle": "Equipes desconhecidos",
    "homologationSemiTrailer": "Carretas desconhecidas",
    "workingShiftGroup": "Grupos de turnos"
  },
  "table": {
    "code": "Código",
    "name": "Nome",
    "dataSource": "Códigos em fontes de informação",
    "state": "Estado",
    "setting": "Ações",
    "endTime": "Não existem mais dados",
    "row": "Fileira",
    "workingShiftGroup": "Grupo de turnos"
  },
  "homologationDriver": {
    "AssociateTeam": "Associar equipe",
    "createTeam": "Criar equipe",
    "AssociateSemiTrailer": "Associar carreta",
    "createSemiTrailer": "Criar carreta",
    "downloadExcel": "Descarregar Planilha Excel",
    "importExcelFile": "Importar Planilha Excel",
    "downloadFileName": "homologacaoCondutor",
    "table": {
      "source": "Fonte de informação",
      "dataSource": "Nome da fonte de informação externa: SAP, ERP’s, outros.",
      "codeExterno": "Código do condutor proveniente da fonte de informação externa: SAP, ERP’s, outros.",
      "codeExternoVehicle": "Código do equipamento proveniente da fonte de informação externa: SAP, ERP’s, outros.",
      "codeExternoSemiTrailer": "Código de la rampla proveniente de la fuente de información externa: SAP, ERP’s, otros.",
      "dataSourceAlias": "Informação do condutor obtida através da fonte de informação externa.",
      "dataSourceVehicle": "Informação do equipamento obtida através da fonte de informação externa.",
      "dataSourceSemiTrailer": "Informação da carreta obtida através da fonte de informação externa.",
      "code": "Código externo",
      "alias": "Informação do condutor",
      "aliasVehicle": "Informação do equipamento",
      "aliasSemiTrailer": "Informação da carreta",
      "codeAndName": "Condutor existente que se atribuirá",
      "codeAndNameVehicle": "Equipamento existente que se atribuirá",
      "codeAndNameSemiTrailer": "Carreta existente que se atribuirá",
      "selectDriver": "Por favor selecione um motorista",
      "selectVehicle": "Por favor selecione um veículo",
      "selectSemiTrailer": "Por favor selecione uma carreta"
    },
    "vehicules": "Veículos",
    "semiTrailers": "Carretas",
    "detail": "Detalhe",
    "code": "Código",
    "name": "Nome",
    "text": "Corresponde ao identificador único do condutor, na qual pode ser sua rota ou outro código definido pela empresa.",
    "textVehicle": "Corresponde ao número de identificação do equipamento, na qual pode ser sua rota ou outro número definido pela empresa.",
    "textSemiTrailer": "Corresponde ao número de identificação da carreta, na qual pode ser sua rota ou outro número definido pela empresa.",
    "filterText": "Selecione o/os items a qual pertence o condutor",
    "filterTextUser": "Selecione o/os items a qual pertence o usuário",
    "source": "Fonte",
    "dataSourceDescent": "Complete os códigos do equipamento provenientes de fontes de informação externas: SAP, ERP`s, outros.",
    "dataSourceSemiTrailerDescent": "Complete os códigos da carreta provenientes de fontes de informação externas: SAP, ERP`s, outros.",
    "type": "Tipo",
    "feedBackDriverOk": "Veículo criado e associado a fonte de informação.",
    "feedBackDriverWarning": "Veículo criado, porém, sem associar a fontes de informação.",
    "feedBackSemiTrailerOk": "Carreta criada e associada à fonte de informação.",
    "feedBackSemiTrailerWarning": "Carreta criada pero Sem associar a fontes de informação.",
    "teamCreateSuccess": "Associação realizada com éxito.",
    "howCreatedExcel": "Descarregar planilha excel?",
    "browserIssue": "Seu navegador não suporta a tag de vídeo.",
    "buttonDownload": "Descarregar planilha de formato",
    "createVehicule": "Criar equipamento",
    "dataSource": "Fontes de informação"
  },
  "modalDriver": {
    "buttonCreat": "Criar condutor",
    "textLabel": "Por favor selecione o arquivo Lista de condutores que deseja carregar na plataforma, o arquivo deve possuir o formato definido no seguinte arquivo:",
    "buttonDelete": "Desativar",
    "teamLabel": "Por favor selecione o arquivo Lista de equipamentos que deseja carregar na plataforma, o arquivo deve possuir o formato definido no seguinte arquivo",
    "buttonActive": "Ativar",
    "buttonCancel": "Cancelar",
    "buttonEdit": "Atualizar condutor",
    "buttonUpdate": "Atualizar",
    "buttonUpdateFile": "Enviar arquivo",
    "buttonDownload": "Descarregar planilha de formato",
    "createDriverTitle": "Criar condutor",
    "deleteDriverTitle": "Desativar condutor",
    "activeDriverTitle": "Ativar condutor",
    "editDriverTitle": "Editar condutor",
    "loading": "Carregando !!!",
    "feedBackDriverOk": "Condutor criado e associado á fonte de informação.",
    "feedBackDriverWarning": "Condutor criado Sem fontes de informação associadas.",
    "feedBackDriverOkEdit": "Condutor atualizado e associado à fonte de informação.",
    "feedBackDriverWarningEdit": "Condutor atualizado sem fontes de informação associadas.",
    "feedBackDriverDeleteOne": "O condutor",
    "feedBackDriverDeleteTwo": "Foi desativado exitosamente.",
    "feedBackDriverActiveOne": "O condutor",
    "feedBackDriverActiveTwo": "foi ativado exitosamente.",
    "feedBackDriverUpdateOne": "dados foram carregados com éxito",
    "feedBackDriverUpdateTwo": "Erro: resolva estes problemas e volte a carregar o arquivo.",
    "feedBackDriverUpdateThree": "Advertência: O sistema permite ingressar dados, porém, poderiam trazer problemas se não forem corrigidos.",
    "code": "Código",
    "name": "Nome",
    "examine": "Examinar",
    "row": "Fileira",
    "type": "Tipo",
    "detail": "Detalhe",
    "dataSource": "Códigos em fontes de informação",
    "downloadExcel": "Descarregar planilha Excel",
    "dataSourceDescent": "Complete os códigos do condutor provenientes de fontes de informação externas: SAP, ERP`s, outros.",
    "selectTags": "Selecione: os items a que pertence o condutor",
    "ErrorDelete": "Erro ao Desativar",
    "isSureToDeleteOne": "Está seguro que deseja Desativar o condutor",
    "isSureToDeleteTwo": "da plataforma ?",
    "isSureToDeleteThree": "* Está ação fará que a partir deste momento não sejam visualizados os dados deste condutor.",
    "isSureToDeleteFour": "¿ Está seguro que deseja ativar o condutor",
    "isSureToDeleteFive": "da plataforma ?",
    "isSureToDeleteSix": "* ativadoEstá ação fará que a partir deste momento sejam visualizados os dados deste condutor.",
    "howCreatedExcel": "¿Descarregar planilha excel?",
    "browserIssue": "Seu navegador não suporta a tag de vídeo.",
    "normalText": "Por favor selecione o arquivo Lista de condutores que deseja carregar na plataforma, o arquivo deve possuir o formato definido no seguinte arquivo:",
    "normalTextUser": "Por favor selecione o arquivo Lista de usuários que deseja carregar na plataforma, o arquivo deve possuir o formato definido no seguinte arquivo:",
    "cognusMailConfig": {
      "title": "Destinatários de vouchers digitais",
      "placeholder": "Digite os e-mails",
      "description": "Corresponde ao grupo de e-mails para o qual será enviado o voucher digital cada vez que este motorista realizar um teste PVT",
      "helpText": "Você pode inserir mais de um e-mail usando uma vírgula, a tecla SPACE ou ENTER como separador."
    },
    "howCreatedExcelAssociateUsers": "Baixar modelo Excel para associar usuários?",
    "normalTextUserAssociateUsers": "Por favor, selecione o arquivo para associar usuários com motoristas que você deseja carregar na plataforma. O arquivo deve ter o formato definido no seguinte documento:",
    "messageErrorResultAssociateUsers": "O resultado do processo de associação de usuários apresentou alguns erros que você deve revisar no arquivo baixado<br />(<b>total de erros</b>: {totalErrors})",
    "downloadFileNameAssociateUsers": "associar-usuarios",
    "downloadFileNameResultAssociateUsers": "resultado-associacao-usuarios"
  },
  "filterDriver": {
    "show": "Mostrar",
    "allDriver": "Todos os condutores",
    "allVehicules": "Todos os equipamentos",
    "allSemiTrailers": "Todas las carretas",
    "associatedDriver": "Condutores associados a fontes de informação",
    "associatedVehicle": "Equipamentos associados a fontes de informação",
    "associatedSemiTrailer": "Carretas associadas a fontes de informação",
    "associatedDriverOne": "Associado a fonte de informação",
    "pendingDriver": "Condutores Sem fontes de informação",
    "desactiveUser": "Usuários desativados",
    "desactiveDriver": "Condutores desativados",
    "desactiveVehicles": "Equipamentos desativados",
    "desactiveSemiTrailers": "Carretas desativadas",
    "activeDriver": "Condutores registrados",
    "activeVehicles": "Equipamentos registrados",
    "activeSemiTrailers": "Carretas registradas",
    "PendingPartnership": "Sem associações a fonte de informação"
  },
  "createDriver": {
    "create": "Criar condutor",
    "createOne": "Criar condutores",
    "import": "Importação do Excel",
    "importOne": "Importar condutores",
    "download": "Descarregar planilha",
    "associateDrivers": "Associar condutores",
    "drivers": "Condutores",
    "downloadFileName": "condutor",
    "importUsers": "Importar Usuários",
    "associateUsers": "Associar Usuários"
  },
  "createUser": {
    "importOne": "Importar usuário",
    "downloadFileName": "usuarios"
  },
  "createVehicules": {
    "creates": "Criar equipamentos",
    "create": "Criar equipamento",
    "import": "Importação do excel",
    "download": "Descarregar planilha",
    "name": "Nome",
    "code": "Código",
    "text": "Corresponde ao número de identificação do condutor, na qual pode ser sua rota ou outro número definido pela empresa.",
    "filterText": "Selecione o/os items a que pertence o equipamento",
    "dataSource": "Códigos em fontes de informação",
    "dataSourceDescent": "Complete os códigos do equipamento provenientes de fontes de informação externas: SAP, ERP`s, outros.",
    "editDriverTitle": "Editar equipamento",
    "feedBackOkEdit": "Equipamento criado e associado à fonte de informação.",
    "feedBackWarningEdit": "Equipamento criado sem fontes de informação associadas.",
    "downloadFileName": "equipamento",
    "downloadFileNameHomologation": "homologationEquipamento"
  },
  "editVehicule": {
    "editVehiculeTitle": "Editar equipamento",
    "name": "Nome",
    "code": "Código",
    "codeText": "Corresponde ao número de identificação do condutor, na qual pode ser sua rota ou outro número definido pela empresa.",
    "filterText": "Selecione a contratada a qual pertence o condutor",
    "dataSource": "Fontes de informação",
    "dataSourceDescent": "Pode criar o condutor sem completar este campo, de todas maneiras deverá completá-lo antes de começar a operar em Gauss control para poder visualizá-lo na plataforma.",
    "buttonEdit": "Atualizar equipamento",
    "feedBackDriverOkEdit": "Equipamento atualizado e associado à fonte de informação.",
    "feedBackDriverWarningEdit": "Equipamento atualizado aem fontes de informação associadas."
  },
  "deleteVehicule": {
    "deleteVehiculeTitle": "Desativar veículo",
    "isSureToDeleteOne": "Está seguro que deseja desativar o equipamento",
    "from": "da plataforma ?",
    "isSureToDeleteThree": "* Está acão fará que a partir deste momentopnão sejam visualizados os dados deste equipamento.",
    "buttonDelete": "Desativar",
    "buttonCancel": "Cancelar",
    "feedBackDriverDeleteOne": "O equipamento",
    "feedBackDriverDeleteTwo": "foi desativado exitosamente.",
    "feedBackDriverDeleteThree": "foi ativado exitosamente."
  },
  "activateVehicule": {
    "activateVehiculeTitle": "Ativar equipamento",
    "isSureToActivateOne": "Está seguro que deseja ativar o veículo",
    "from": "da plataforma ?",
    "isSureToActivateThree": "* Está ação fará que a partir desde momento sejam visualizados os dados deste veículo.",
    "buttonActivate": "Ativar",
    "buttonCancel": "Cancelar",
    "feedBackVehiculeActivateOne": "O equipamento",
    "feedBackVehiculeActivateTwo": "foi desativado exitosamente.",
    "feedBackVehiculeActivateThree": "foi ativado exitosamente."
  },
  "updateVehicule": {
    "import": "Importar equipamentos",
    "examine": "Examinar",
    "activateVehiculeTitle": "Ativar veículo",
    "buttonUpdateFile": "Enviar arquivo",
    "row": "Fileira",
    "type": "Tipo",
    "feedBackVehiculeUpdateTwo": "Erro: resolva estes problemas e volte a carregar o arquivo.",
    "feedBackVehiculeUpdateThree": "Advertência: o sistema permite ingressar dados, porém poderão trazer problemas se não forem corrigidos",
    "feedBackVehiculeUpdateOne": "dados foram carregados com éxito",
    "isSureToActivateOne": "¿ Está seguro que deseja Ativar ao veículo",
    "detail": "detalhe",
    "from": "da plataforma ?",
    "isSureToActivateThree": "* Está acção hará que desde este momento se visualicen os dados deste veículo.",
    "buttonActivate": "Atualizar",
    "buttonCancel": "Cancelar",
    "feedBackDriverUpdateOne": "Dados foram carregados com éxito.",
    "feedBackVehiculeActivateOne": "O equipamento",
    "feedBackVehiculeActivateTwo": "Foi desativado exitosamente.",
    "normalText": "Por favor selecione o arquivo Lista de equipamentos que deseja carregar na plataforma, o arquivo deve possuir o formato definido no seguinte arquivo:"
  },
  "createSemiTrailers": {
    "creates": "Criar carretas",
    "create": "Criar carreta",
    "import": "Importação do excel",
    "download": "Descarregar planilha",
    "name": "Nome",
    "code": "Código",
    "text": "Corresponde ao número de identificação da carreta, no qual pode ser sua placa ou outro número definido pela empresa.",
    "filterText": "selecione o/os items a que pertence à carreta",
    "dataSource": "Códigos em fontes de informação",
    "dataSourceDescent": "Complete os códigos da carreta provenientes de fontes de informação externas: SAP, ERP`s, outros.",
    "editDriverTitle": "Editar carreta",
    "feedBackOkEdit": "Carreta criada e associada à fonte de informação.",
    "feedBackWarningEdit": "Carreta criada Sem fontes de informação associadas."
  },
  "editSemiTrailer": {
    "editSemiTrailerTitle": "Editar carreta",
    "name": "Nome",
    "code": "Código",
    "codeText": "Corresponde ao número de identificação da carreta, no qual pode ser sua placa ou outro número definido pela empresa.",
    "filterText": "Selecione o/os transportista ao que pertence a carreta",
    "dataSource": "Fontes de informação",
    "dataSourceDescent": "Pode criar o condutor sem completar este campo, de todas maneiras deverá completá-lo antes de começar a operar em Gauss control para poder visualizá-lo na plataforma.",
    "buttonEdit": "Atualizar carreta",
    "feedBackDriverOkEdit": "Carreta atualizada e associada à fonte de informação.",
    "feedBackDriverWarningEdit": "Carreta atualizada sem fontes de informação associadas."
  },
  "deleteSemiTrailer": {
    "deleteSemiTrailerTitle": "Desativar carreta",
    "isSureToDeleteOne": "Está seguro que deseja desativar a carreta",
    "from": "da plataforma ?",
    "isSureToDeleteThree": "* Está ação fará que a partir desde momento não sejam visualizados os dados desta carreta.",
    "buttonDelete": "Desativar",
    "buttonCancel": "Cancelar",
    "feedBackDriverDeleteOne": "A carreta",
    "feedBackDriverDeleteTwo": "foi desativado exitosamente.",
    "feedBackDriverDeleteThree": "foi ativado exitosamente."
  },
  "activateSemiTrailer": {
    "activateSemiTrailerTitle": "Ativar carreta",
    "isSureToActivateOne": "Está seguro que deseja ativar a carreta?",
    "from": "da plataforma ?",
    "isSureToActivateThree": "* Está ação fará que a partir desde momento sejam visualizados os dados desta carreta.",
    "buttonActivate": "Ativar",
    "buttonCancel": "Cancelar",
    "feedBackSemiTrailerActivateOne": "A carreta",
    "feedBackSemiTrailerActivateTwo": "foi desativado exitosamente.",
    "feedBackSemiTrailerActivateThree": "foi ativado exitosamente."
  },
  "updateSemiTrailer": {
    "import": "Importar carretas",
    "examine": "Examinar",
    "activateSemiTrailerTitle": "Ativar carreta",
    "buttonUpdateFile": "Enviar arquivo",
    "row": "Fileira",
    "type": "Tipo",
    "feedBackSemiTrailerUpdateTwo": "Erro: resolva estes problemas e volte a carregar o arquivo.",
    "feedBackSemiTrailerUpdateThree": "Advertência: o sistema permite ingressar dados, porém poderão trazer problemas se não forem corrigidos",
    "feedBackSemiTrailerUpdateOne": "dados foram carregados com éxito",
    "isSureToActivateOne": "Está seguro que deseja ativar a carreta?",
    "detail": "detalhe",
    "from": "da plataforma ?",
    "isSureToActivateThree": "* Está ação fará que a partir desde momento sejam visualizados os dados desta carreta.",
    "buttonActivate": "Atualizar",
    "buttonCancel": "Cancelar",
    "feedBackDriverUpdateOne": "dados foram carregados com éxito.",
    "feedBackSemiTrailerActivateOne": "A carreta",
    "feedBackSemiTrailerActivateTwo": "foi desativado exitosamente.",
    "normalText": "Por favor selecione o arquivo Lista de carretas que deseja carregar na plataforma, o arquivo deve possuir o formato definido no seguinte arquivo:"
  },
  "roles": {
    "FatigueModuleFullAccess": "Permite visualizar reportabilidadee de módulo biocompatibilidade completa (resumo, detalhe e condutor).",
    "RoadWarningModuleFullAccess": "Permite visualizar reportabilidadee de módulo eventos de sonolência completa (resumo, detalhe e condutor).",
    "AccountManagerReadOnly": "Permite visualizar lista de condutores, equipamentos e geozonas configurados na plataforma.",
    "BehaviorModuleFullAccess": "Permite visualizar reportabilidade de módulo condutual completa (resumo, detalhe e condutores).",
    "ManageFullAccess": "Permite visualizar e administrar todas as tarefas ativadas no gestionador.",
    "AccountManagerCrudAccess": "Permite visualizar e configurar a plataforma (Criar, editar e Desativar) condutores, equipamentos. categorias e geozonas. Além do mais permite associar equipamentos e condutores desconhecidos com seus respectivos códigos de fontes de informação.",
    "AccountManagerUserRoleAccess": "Permite visualizar a plataforma e configurar usuários (criar, editar e desativar).",
    "ManageReadAccess": "Permite visualizar todas as tarefas ativadas no gestionador.",
    "CFLModuleFullAccess": "Permite visualizar reportabilidade de módulo nfa completa (resumo, detalhe e condutor).",
    "AssignmentFullAccess": "Permite visualizar e atribuir condutores a equipamentos.",
    "WaitingTimesFullAccess": "Permite visualizar reportabilidade de módulo tempos de espera.",
    "UserProfileFullAccess": "Permite ao usuário visualizar e modificar sua informação pessoal.",
    "ApiInjection": "Permite usar os serviços de integração de API. Através destes serviços é posssívO injetar eventos e dados de telemetria na plataforma Gauss Control.",
    "FormFullAccess": "Permite acessar e administrar formulários através de aplicação mobile e visualizar reportabilidade da frota e inspeções.",
    "FlowRequestsAdmin": "Permite administrar fluxos de veículos para uma rota determinada ou outros.",
    "FlowRequestsApplicant": "Permite solicitar fluxos de veículos para uma rota determinada ou outros.",
    "AlertnessInTimelineAccess": "Habilita a curva de alerta nas vistas que mostram as jornadas de trabalho como linha de tempo (timeline).",
    "FFDSleepModuleFullAccess": "Permite visualizar reportabilidade de módulo FFD pulseiras de sono.",
    "FFDPVTModuleFullAccess": "Permite visualizar reportabilidade de módulo Cognus teste pvt.",
    "ReclassificationInTasksManagementAccess": "Permite reclassificar tarefas no gerenciador",
    "DeanonymizationInTasksManagementAccess": "Permite tarefas de anonimato no gerenciador",
    "ManageCancelAccess": "Permite cancelar tarefas no gerenciador",
    "AnonymousFormReadAccess": "Permite que você visualize as inspeções que não possuem nenhuma categoria atribuída.",
    "ReportBIFullAccess": "Permite visualizar a reportabilidade de acordo com as permissões que o usuário possui.",
    "MediaDmsAccess": "Permite visualizar material multimídia associado a eventos DMS",
    "MediaDashcamAccess": "Permite visualizar material multimídia associado a eventos DASHCAM",
    "MediaDownloadAccess": "Permite visualizar e baixar material multimídia associado a eventos",
    "MediaListenAudioAccess": "Permite ouvir áudio de material multimídia associado a eventos",
    "AccountManagerCrudAccessTags": "Permite visualizar a plataforma e adicionar categorias.",
    "AccountManagerCrudAccessGeozones": "Permite visualizar a plataforma e configurar geozonas (criar, editar e desativar).",
    "AccountManagerCrudAccessVehicles": "Permite visualizar a plataforma e configurar veículos e rampas (criar, editar e desativar). Também permite associar os veículos e rampas às suas respectivas fontes de informação.",
    "AccountManagerCrudAccessDrivers": "Permite visualizar a plataforma e configurar condutores (criar, editar e desativar). Também permite que os motoristas sejam associados às suas respectivas fontes de informação.",
    "FormFullDynamicListAccess": "Permite criar e editar várias listas de dados utilizadas no módulo Formulários na aplicação mobile",
    "MediaCognusFaceVerificationAccess": "Permite visualizar material multimídia associado aos eventos Cognus",
    "MediaUnidentifiedDriverAccess": "Permite visualizar material multimídia associado a eventos de motorista não reconhecidos",
    "SaasApiConsumer": "Permite usar os serviços de integração de API. Através destes serviços é posssível injetar eventos e dados de telemetria na plataforma Gauss Control."
  },
  "geozone": {
    "base": "Base",
    "principal": "Mandante",
    "client": "Cliente",
    "onDuty": "Condução",
    "productive": "Produtiva",
    "stopped": "Detenção",
    "withoutRest": "Tempo de espera",
    "waitingtime": "Tempo de espera",
    "workingplace": "Produtiva",
    "activate": "Ativar geozona",
    "activateText": "Está seguro que deseja ativar a geozona",
    "howCreatedExcel": "Descarregar planilha excel?",
    "isSureActivateText": "* Está acão fará que a partir desde momento sejam visualizados os dados desta geozona.",
    "trip": "Viaem",
    "row": "Fileira",
    "type": "Tipo",
    "import": "Importar geozona(s)",
    "importExcel": "Importação do Excel",
    "deactivate": "Desativar Geozona",
    "code": "Código",
    "detail": "Detalhe",
    "show": "Mostrar",
    "featureTextOne": "Característica",
    "allGeozone": "Todas as geozonas",
    "geozoneList": "Lista de geozonas",
    "geozoneDeactivated": "Geozonas desativadas",
    "geozoneActive": "Geozonas registradas",
    "downloadExcel": "Descarregar planilha",
    "downloadFileName": "geozona",
    "geozoneName": "Nome geozona",
    "examine": "Examinar",
    "isSureToDeleteOne": "Está seguro que deseja desativar a geozona",
    "isSureToDeleteTwo": "da plataforma ?",
    "browserIssue": "Your browser does not support the video tag.",
    "isSureToDeleteThree": "* Está acão fará que a partir desde momento não sejam visualizados os dados desta geozona.",
    "feedBackGeozoneUpdateThree": "Advertência: o sistema permite ingressar dados, porém poderão trazer problemas se não forem corrigidos",
    "cancel": "Cancelar",
    "mapMessageOne": "Oh snap!",
    "mapMessageTwo": "you cant draw that!",
    "feedBackGeozoneEditOne": "A geozona",
    "feedBackGeozoneEditTwo": "foi desativada exitosamente.",
    "feedBackGeozoneUpdateTwo": "Erro: resolva estes problemas e volte a carregar o arquivo.",
    "buttonDelete": "Desativar",
    "feedBackGeozoneUpdateOne": "dados foram carregados com éxito",
    "updatText": "Por favor selecione o arquivo Lista de geozona que deseja carregar na plataforma, o arquivo deve possuir o formato definido no seguinte arquivo:",
    "modalCreate": {
      "create": "Criar Geozona",
      "import": "Importar geozona(s)",
      "name": "Nome",
      "features": "Características geozona",
      "featureText": "selecione a(s) característica(s) desta geozona",
      "baseText": {
        "base": "Esta característica determina a cor com que se mostra a estadía em geozona na visualização de jornadas.",
        "principal": "Esta característica determina a cor com que se mostra a estadía em geozona na visualização de jornadas.",
        "client": "Esta característica determina a cor com que se mostra a estadía em geozona na visualização de jornadas.",
        "onDuty": "Esta característica determina a cor com que se mostra a estadía em geozona na visualização de jornadas.",
        "stopped": "Esta característica determina a cor com que se mostra a estadía em geozona na visualização de jornadas.",
        "withoutRest": "Esta característica determina se a detenção do condutor nesta zona se considera como trabalho (en vez de descanso). Isto afeta os indicadores de fadiga",
        "productive": "Esta característica determina se o tempo destadía dos veículos se mostra no módulo de tempos de espera.",
        "trip": "Esta característica determina se a geozona será considerada para a criação e finalização de viagens no módulo Comportametal. Se não tem esta característica, não serão geradas viagens desde/até esta geozona.",
        "workingplace": "Esta característica determina se a detenção do condutor nesta zona se considera como trabalho (en vez de descanso). Isto afeta os indicadores de fadiga.",
        "waitingtime": "Esta característica determina se o tempo destadía dos veículos se mostra no módulo de tempos de espera."
      },
      "code": "Código",
      "codeText": "Corresponde ao código identificador da geozona.",
      "createSucces": "Geozona criada exitosamente.",
      "_codeText": "Corresponde ao código identificador da geozona."
    },
    "modalEdit": {
      "edit": "Editar Geozona",
      "editText": "Editar",
      "deactivateText": "Desativar",
      "activateText": "Ativar",
      "features": "Características geozona",
      "featureText": "selecione as características desta geozona",
      "featureTextOne": "Característica",
      "name": "Nome",
      "baseText": {
        "base": "Esta característica determina a cor com que se mostra a estadía em geozona na visualização de jornadas.",
        "principal": "Esta característica determina a cor com que se mostra a estadía em geozona na visualização de jornadas.",
        "client": "Esta característica determina a cor com que se mostra a estadía em geozona na visualização de jornadas.",
        "onDuty": "Esta característica determina a cor com que se mostra a estadía em geozona na visualização de jornadas.",
        "stopped": "Esta característica determina a cor com que se mostra a estadía em geozona na visualização de jornadas.",
        "withoutRest": "Esta característica determina se a detenção do condutor nesta zona se considera como trabalho (en vez de descanso). Isto afeta os indicadores de fadiga",
        "productive": "Esta característica determina se o tempo destadía dos veículos se mostra no módulo de tempos de espera.",
        "trip": "Esta característica determina se a geozona será considerada para a criação e finalização de viagens no módulo Comportametal. Se não tem esta característica, não serão geradas viagens desde/até esta geozona.",
        "workingplace": "Esta característica determina se a detenção do condutor nesta zona se considera como trabalho (en vez de descanso). Isto afeta os indicadores de fadiga.",
        "waitingtime": "Esta característica determina se o tempo destadía dos veículos se mostra no módulo de tempos de espera."
      },
      "code": "Código",
      "codeText": "Corresponde ao código identificador da geozona.",
      "buttonEdit": "Atualizar Geozona",
      "editSucces": "Geozona atualizada com sucesso.",
      "modelActivate": {
        "isSureToActivateOne": "* Está acão fará que a partir desde momento sejam visualizados os dados desta geozona.",
        "isSureToActivateTwo": "da plataforma ?",
        "buttonActivate": "Ativar",
        "feedBackGeozoneActivateTwo": "foi ativada exitosamente."
      }
    }
  },
  "accountUser": {
    "alertnessintimelineaccess": "Habilitar curva de alerta em linhas de tempo de jornadas",
    "cflmodulefullaccess": "Ver Módulo NFA",
    "ffdsleepmodulefullaccess": "Ver Módulo Fitness for duty pulseiras de sono",
    "ffdpvtmodulefullaccess": "Ver Módulo Cognus teste pvt",
    "accountmanagercrudaccess": "Configurar entidades",
    "accountmanagerreadonly": "Visualizar configuração de plataforma",
    "accountmanageruserroleaccess": "Configurar contas de usuário",
    "apiinjection": "Fornecedor de dados",
    "assignmentfullaccess": "Atribuir condutores a equipamentos",
    "behaviormodulefullaccess": "Ver Módulo Comportamental",
    "fatiguemodulefullaccess": "Ver Módulo Biocompatibilidade",
    "anonymousformreadaccess": "Ver inspeções anonimato",
    "formfullaccess": "Administrar Formulários",
    "managefullaccess": "Administrar tarefas",
    "managereadaccess": "Ver tarefas",
    "reclassificationintasksmanagementaccess": "Reclassificar tarefas",
    "deanonymizationintasksmanagementaccess": "Desanonimizar tarefas",
    "managecancelaccess": "Cancelar tarefas",
    "roadwarningmodulefullaccess": "Ver Módulo Eventos de sonolência",
    "waitingtimesfullaccess": "Ver Módulo tempos de espera",
    "userprofilefullaccess": "Ver perfil de usuário",
    "userAccount": "Lista de usuários",
    "showUsers": "Mostrar: Todos os usuários",
    "allUsers": "Todos os usuários",
    "deactivateUsers": "usuários desativados",
    "activateUsers": "usuários registrados",
    "userRole": "Permissões: Todos",
    "userRoleTitle": "Permissões",
    "createUser": "Criar usuário",
    "userSuccess": "usuário criado exitosamente.",
    "name": "Nome",
    "email": "E-mail (username)",
    "password": "Senha",
    "passwordError": "As Senhas não são iguais",
    "repeatPassword": "Repetir Senha",
    "currentPassword": "Senha atual",
    "newPassword": "Nova senha",
    "isAdmin": "É administrador",
    "rol": "Permissões",
    "labelSelection": "selecione um ou mais permissões para este usuário",
    "rolLabel": "Corresponde ao conjunto de Permissões e funções da plataforma que está atribuída ao usuário.",
    "actions": "Ações",
    "endOfTime": "Não existem mais dados",
    "editUser": "Editar usuário",
    "ActualizarUser": "Atualizar usuário",
    "updatePassword": "Atualizar Senha",
    "isUpdatePassword": "Senha atualizado",
    "userActivated": "usuário atualizado",
    "deactivateUser": "Desativar usuário",
    "activateUser": "Ativar usuário",
    "activateUserOne": "Ativar",
    "deactivateUserLabel": "Está seguro que deseja desativar o usuário",
    "deactivateUserLabelOne": "da plataforma ?",
    "deactivateUserLabelTwo": "* Está ação fará que a partir deste momento não sejam visualizados os dados deste usuário",
    "cancel": "Cancelar",
    "userTextOne": "O usuário",
    "userTextTwo": "Foi desativado, a partir deste momento não poderá acessar à plataforma.",
    "userTextThree": "Foi ativado, a partir deste momento poderá acessar à plataforma",
    "isSureToActivateOne": "Está seguro que deseja ativar o usuário?",
    "isSureToActivateTwo": "da plataforma ?",
    "isSureToActivateThree": "* Está acão fará que a partir deste momento sejam visualizados os dados deste usuário.",
    "editPassWord": "Restabelecer Senha",
    "accountSettings": {
      "title": "Configuração do cliente",
      "save": "Salvar"
    },
    "flowrequestsadmin": "Ver Módulo fluxos - Administrador",
    "flowrequestsapplicant": "Ver Módulo fluxos - Aplicante",
    "reportbifullaccess": "Ver relatórios",
    "mediadmsaccess": "Veja o material multimídia DMS na cabine",
    "mediadashcamaccess": "Veja o material multimídia DASHCAM",
    "mediadownloadaccess": "Baixar mídia",
    "medialistenaudioaccess": "Ouça o áudio da mídia",
    "accountmanagercrudaccesstags": "Categorias de configuração",
    "accountmanagercrudaccessgeozones": "Configuração de geozonas",
    "accountmanagercrudaccessvehicles": "Veículos de configuração e rampas",
    "accountmanagercrudaccessdrivers": "Condutores de configuração",
    "formfulldynamiclistaccess": "Configuração de listas dinâmicas no formulário",
    "mediacognusfaceverificationaccess": "Veja o material de inscrição da Cognus",
    "mediaunidentifieddriveraccess": "Ver filmagem de reconhecimento facial com falha",
    "passwordChecklist": {
      "minLength": "A senha tem mais de 8 caracteres.",
      "specialChar": "A senha contém caracteres especiais (!@#$%^&*).",
      "number": "A senha contém um número (0-9).",
      "capital": "A senha contém uma letra maiúscula (A-Z).",
      "lowercase": "A senha contém uma letra minúscula (a-z).",
      "match": "As senhas coincidem."
    },
    "massiveActions": "Ações Massivas",
    "saasapiconsumer": "Consumidor de API SaaS"
  },
  "accountAssigment": {
    "withoutConnection": "Veículos Sem conexão",
    "anonymousDriver": "(condutor anónimo)",
    "team": "equipamento",
    "hour": "Hora",
    "driver": "condutor",
    "vehicleCode": "Código veículo",
    "categorie": "Categorias",
    "assignDate": "Data atribuição",
    "assignTime": "tempo atribuído",
    "detail": "detalhes",
    "headTitle": "Lista de atribuíção",
    "paragraphTitle": "Nesta vista podrerá revisar os condutores atribuídos a um veículo neste momento. Se um condutor não aparece é porque não está atribuído a nenhum equipamento"
  },
  "workingShiftGroup": {
    "name": "Nome",
    "workingShiftGroupType": "Tipo de turno",
    "workingShiftStructureDays": "Dias da estrutura de turno",
    "workingShiftStartDate": "Data de início do turno",
    "workingShiftGroupTypeHelp": "Corresponde ao tipo de estrutura do turno, sendo dinâmico quando não segue um padrão fixo ou com estrutura fixa quando o padrão se repete no tempo, 5x2, 10x10, etc.",
    "workingShiftStructureDaysHelp": "Corresponde a quantidade total de dias que compoem a estrutura de turnos (dias de trabalho e dias de descanso).",
    "workingShiftStartDateHelp": "Corresponde a data que começará a trabalhar o grupo de trabalho.",
    "dynamicWorkingShift": "Turno dinâmico",
    "fixedStructureWorkingShift": "Turno com estrutura fixa",
    "doesNotApply": "Não se aplica",
    "deactivateWorkingShiftGroup": "Eliminar grupo de turno",
    "deactivateWorkingShiftGroupLabel": "¿Tem certeza que quer eliminar o grupo de turno",
    "deactivateWorkingShiftGroupLabelOne": "?",
    "deactivateWorkingShiftGroupLabelTwo": "* Se este grupo alguma vez teve pessoas associadas, toda a informação histórica será perdida.",
    "cancel": "Cancelar",
    "workingShiftGroupTextOne": "O grupo de turno",
    "workingShiftGroupTextTwo": "foi eliminado.",
    "deleteText": "Eliminar",
    "editText": "Editar",
    "cantDeleteHelp1": "Não pode eliminar este grupo de turno.",
    "cantDeleteHelp2": "Existem usuários atribuídos a este grupo de trabalho.",
    "editModalTitle": "Editar grupo de turno",
    "buttonEdit": "Atualizar grupo de turno",
    "feedBackOkEdit": "Grupo de turno atualizado.",
    "createModalTitle": "Criar grupo de turno",
    "buttonCreate": "Criar grupo de turno",
    "feedBackOkCreate": "Grupo de turno criado.",
    "form": {
      "name": "Nome do grupo",
      "namePlaceholder": "Escreva o nome do grupo de turno",
      "type": "Tipo de turno",
      "typeInfo": "Selecione o checkbox turno dinâmico se a estrutura deste turno não segue um padrão fixo.",
      "typeHelp": "Turno que não segue uma estrutura com um padrão fixo.",
      "workingShiftStructureDays": "Dias da estrutura de turno",
      "workingShiftStructureDaysPlaceholder": "Escreva a quantidade de dias da estrutura de turno (incluindo descansos)",
      "workingShiftStructureDaysHelp": "Corresponde a quantidade total de dias que compoem a estrutura de turno (dias de trabalho e dias de descanso).",
      "planification": "Planejamento horário do grupo de turno",
      "planificationHelp": "Corresponde ao planejamento de hora de início e fim para cada dia de trabalho dentro do turno além do planejamento dos dias de descanso.",
      "planificationHelp2": "Este planejamento se repetirá de forma cíclica a partir da data de início inserida.",
      "planificationTable": {
        "days": "DIA",
        "workingDayType": "Tipo de jornada",
        "workType": "Trabalho",
        "restType": "Descanso",
        "startTime": "Hora de início",
        "endTime": "Hora de fim",
        "hourPlaceholder": "Introduza hora"
      },
      "workingShiftStartDate": "Data de início do turno",
      "workingShiftStartDatePlaceholder": "Introduza a data de início para este grupo de turno",
      "workingShiftStartDateHelp": "Corresponde a data que começará a trabalhar o grupo de trabalho.",
      "allowedTimeFFD": "Tempo permitido de envío de relatório Cognus (mins)",
      "allowedTimeFFDPlaceholder": "Introduza o tempo permitido",
      "allowedTimeFFDHelp": "Tempo de antecedência à hora de início de jornada, segundo a cual deverá ser enviado o informe de Cognus PVT.",
      "allowedTimeFFDHelp2": "Exemplo: Se o tempo de antecedência é de 20 minutos e a hora de início de jornada é 8:00 am, então o informe será enviado aproximadamente às 7:40 am.",
      "maxLateTimeFFD": "Máximo tempo permitido para atraso na avaliação Cognus (min.)",
      "maxLateTimeFFDPlaceholder": "Introduza o tempo permitido",
      "maxLateTimeFFDHelp": "Tempo máximo permitido que o sistema vai esperar para avaliar o Cognus de uma pessoa de forma posterior ao início de jornada.",
      "maxLateTimeFFDHelp2": "Exemplo: é desejado que os individuos que realizam o teste Cognus acima de 31 minutos ou mais depois do inicio de jornada sejam registrados como “incidente de realização”, então, o parâmetro deve ser configurado em 30 minutos.",
      "maxAdvanceTimeFFD": "Tempo máximo permitido de antecipação na avaliação Cognus (min.)",
      "maxAdvanceTimeFFDPlaceholder": "Introduza o tempo permitido",
      "maxAdvanceTimeFFDHelp": "Tempo máximo permitido que o sistema irá considerar para recebir informação de avaliação de teste Cognus antes da hora de início de jornada.",
      "maxAdvanceTimeFFDHelp2": "Exemplo: é desejável que as pessoas tenham a oportunidade de realizar o teste Cognus até 2 horas antes do início de jornada, então o parâmetro deve ser configurado em 120 minutos.",
      "mailRecipients": "E-mails de notificação Cognus",
      "mailRecipientsPlaceholder": "Introduza os e-mails separados por uma vírgula",
      "mailRecipientsHelp": "Corresponde à lista de e-mails de notificação dos estados de reprovação de avaliação Cognus e de incidentes de realização."
    }
  },
  "accountTag": {
    "header": {
      "title": "Categorias"
    },
    "card": {
      "list": {
        "title": "Categorias",
        "create": "Criar Categorias",
        "name": "Nome",
        "click": "Faça click para agregar um item",
        "action": "Ações",
        "label_alert": "O nome da categoria deve ter ao menos uma letra",
        "legend_text": "Não há Categorias criadas",
        "placeholder": "Agregar uma categoria ...",
        "label": "Adicione outra categoria pressionando Enter ou cancele pressionando Esc"
      },
      "item": {
        "title": "Items de categoria",
        "create": "Agregar item",
        "name": "Nome",
        "action": "Ações",
        "legend_text": "Não há items criados",
        "label": "Adicione outro Item presionando Enter ou cancelar presionando Esc",
        "label_alert": "O Nome do item só pode conter letras e/ou números, ter ao menos um caracter e não começas com um número.",
        "placeholder": "Agregar um item à categoria",
        "btn_cancel": "Cancelar",
        "btn_save": "Salvar"
      },
      "input": {
        "addItemLabel": "agregar item",
        "labelAlert": "O nome da categoria deve ter ao menos uma letra"
      },
      "toastrLabel": {
        "info": "Informação",
        "error": "Erro",
        "confirm": "Sim",
        "cancel": "Não",
        "delete": "Eliminar",
        "create": "Criar",
        "questionPart1": "Esta seguro que quer guardar as seguintes mudanças na categoria",
        "questionPart1Cancel": "Esta seguro que quer cancelar as mudanças? Perderá todas suas modificações.",
        "caution": "Esta ação fará que a rastreabilidade histórica dos items eliminados seja eliminada da plataforma.",
        "allTagsCreated": "Todas modificações guardadas com éxito.",
        "someTagsCreated": "Algumas mudanças não foram guardados com éxito.",
        "someTagsCreatedDetail": "Modificações não guardadas:",
        "noTagsCreated": "Nenhuma modificação pode ser guardada.",
        "tagsCreationError": "As modificações não foram guardadas, tente novamente"
      }
    }
  },
  "accountList": {
    "header": {
      "title": "Listas de checklist digitais"
    },
    "card": {
      "list": {
        "title": "Listas",
        "create": "Criar listas",
        "name": "Nome",
        "click": "Faça click para agregar uma lista",
        "action": "Ações",
        "label_alert": "O Nome da lista só pode conter letras e/ou números e ter ao menos uma caracter.",
        "legend_text": "Não há listas criadas",
        "placeholder": "Agregar uma lista ...",
        "label": "Adicione outra lista pressionando Enter o cancelar pressionando Esc"
      },
      "item": {
        "title": "Items de lista",
        "create": "Agregar item",
        "name": "Nome",
        "action": "Ações",
        "legend_text": "Não há items criados",
        "label": "Adicione outro Item presionando Enter o cancelar presionando Esc",
        "label_alert": "O Nome do item só pode conter letras e/ou números e ter ao menos um caracter.",
        "placeholder": "Agregar um item à lista",
        "btn_cancel": "Cancelar",
        "btn_cancel_help": "Para voltar a editar a lista deve guardar ou cancelar.",
        "btn_save": "Salvar",
        "editItem": "Editar item"
      },
      "input": {
        "addItemLabel": "agregar item",
        "labelAlert": "O Nome da lista deve ter ao menos uma letra"
      },
      "toastrLabel": {
        "info": "Informação",
        "error": "Erro",
        "confirm": "Sim",
        "cancel": "Não",
        "delete": "Eliminar",
        "create": "Criar",
        "update": "Editar",
        "questionPart1": "Esta seguro que quer guardar as seguintes modificações na lista",
        "questionPart1Cancel": "Esta seguro que quer cancelar as mudanças? Perderá todas suas modificações.",
        "questionPart1DeleteList": "Está seguro que quer eliminar a lista?",
        "cautionListDelete": "Eliminar uma lista que está sendo utilizada por um checklist digital poderia gerar comportamentos inesperados.",
        "allItemsCreated": "Todos as modificações guardadas com éxito.",
        "someItemsCreated": "Algumas modificações no foram guardados com éxito.",
        "someItemsCreatedDetail": "Alterações não salvas:",
        "noItemsCreated": "Nenhuma alteração pôde ser salva.",
        "itemsCreationError": "As modificações não foram guardadas, tente novamente",
        "listDeleted": "A lista foi eliminada com exito.",
        "listDeletedError": "A lista não pode ser eliminada.",
        "listCreated": "A lista foi criada com exito.",
        "listCreatedError": "A lista não pode ser criada."
      }
    }
  },
  "accountExtendedProperty": {
    "title": "Atributos adicionais",
    "table": {
      "name": "Nome",
      "dataType": "Tipo de dado",
      "owner": "Proprietário",
      "actions": "Ações",
      "date": "Data",
      "text": "Texto",
      "person": "Pessoa",
      "vehicle": "Equipamento",
      "semitrailer": "Carreta"
    },
    "buttons": {
      "createExtendedProperty": "Criar atributo"
    },
    "modal": {
      "buttonCreate": "Criar atributo",
      "buttonDelete": "Eliminar",
      "editText": "Editar",
      "buttonCancel": "Cancelar",
      "buttonEdit": "Atualizar atributo",
      "buttonUpdate": "Atualizar",
      "createTitle": "Criar atributo",
      "deleteTitle": "Eliminar atributo",
      "editTitle": "Editar atributo",
      "loading": "Carregando !!!",
      "feedBackOk": "Atributo criado.",
      "feedBackOkEdit": "Atributo atualizado.",
      "feedBackDeleteOne": "O atributo",
      "feedBackDeleteTwo": "foi eliminado exitosamente.",
      "name": "Nome",
      "errorDelete": "Erro ao eliminar",
      "isSureToDeleteOne": "Está seguro que deseja eliminar o atributo",
      "isSureToDeleteTwo": "da plataforma ?",
      "isSureToDeleteThree": "Está acão fará que a partir deste momento os propietários deste atributo e os formulários aos que afeta percam esta informação.",
      "buttonOK": "Ok"
    },
    "filter": {
      "show": "Mostrar",
      "allProperties": "Todos os atributos",
      "person": "Atributos de pessoa",
      "vehicle": "Atributos de equipamento",
      "semiTrailer": "Atributos de carreta"
    },
    "help": {
      "title": "Representan os atributos adicionais que se poderão configurar para uma pessoa ou um equipamento, por exemplo: data de licença de conduzir, carreta de um equipamento, cursos vencidos, entre outros. Isto será visualizado e deverá ser completado tanto em perguntas de inspeções como na criação de equipamentos e pessoas.",
      "dataType": "Representa se o atributo corresponde a um texto ou uma data específica. Por exemplo: data de vencimento de uma licença de conduzir ou carreta de um equipamento em particular.",
      "owner": "Corresponde à entidade (equipamentos, carretas ou pessoas) aos que afeta este atributo.",
      "formName": "Escreva o nome para este atributo",
      "formDataType": "selecione o tipo de dado deste atributo",
      "formOwner": "selecione a quem afeta este atributo"
    }
  },
  "others": {
    "categories": "Categorias",
    "selectOneItem": "Selecione ao menos um item",
    "loading": "Carregando",
    "incorrectFormat": "O formato do arquivo está incorrecto",
    "noData": "Não há dados",
    "downloadFormat": "Descarregar planilha de formato",
    "save": "Guardar",
    "categoriesHelp": "Configure as categorias para os permissões selecionados",
    "selectOneItemCategories": "Categorias para todas as permissões: Selecione um item para cada categoria.",
    "selectMultipleItemsCategories": "Categorias para permissões módulo gerenciador: Selecione um ou mais itens para cada categoria a visualizar no módulo gerenciador.",
    "changeStateMultipleSelectQuestion": "Tem certeza que é para agregar outras permissões, além das permissões do gerenciador, para este usuário?",
    "changeStateMultipleSelectWarning": "Ao realizar esta ação todas as categorias atribuídas a este usuário serão apagadas e deverão ser completadas novamente.",
    "categoryAccessDenied": "Todos os itens nesta categoria estão desabilitados, pois as permissões não correspondem às do usuário atual",
    "selectOnlyOneItem": "Selecione apenas um item por categoria",
    "disclaimerCategories": "As alterações feitas nas Categorias serão refletidas na plataforma no dia",
    "formWithErrors": "Formulário com erros",
    "reviewInformationBeforeSending": "Revise as informações do formulário antes de enviá-lo",
    "at": "às",
    "shouldSelectOnlyOneItem": "Você deve selecionar apenas um item",
    "has": "tem",
    "disclaimerAssociateUsers": "<b>IMPORTANTE</b>: Após finalizar o processo, <b>VOCÊ DEVE</b> salvar o arquivo Excel baixado para consultar o resumo do processo."
  },
  "date": {
    "format": "DD-MM-YYYY",
    "formatShort": "DD-MM",
    "graphFormatTooltip": "%d-%m-%Y",
    "graphFormatXAxis": "%d-%m"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/account/account.js